import ProgramChanges from "@/components/changelog/program-changes"
import ChangelogProvider from "@/components/changelog/context/changelog-provider"

export default function ProgramChangesPage() {
    return <ChangelogProvider>
        <ProgramChanges />
    </ChangelogProvider>
}
